import { render, staticRenderFns } from "./templateDetail.vue?vue&type=template&id=63461843&scoped=true&"
import script from "./templateDetail.vue?vue&type=script&lang=js&"
export * from "./templateDetail.vue?vue&type=script&lang=js&"
import style0 from "./templateDetail.vue?vue&type=style&index=0&id=63461843&prod&scoped=true&lang=less&"
import style1 from "./templateDetail.vue?vue&type=style&index=1&id=63461843&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63461843",
  null
  
)

export default component.exports